import { render, staticRenderFns } from "./tank.vue?vue&type=template&id=37d4e77a&scoped=true&"
import script from "./tank.vue?vue&type=script&lang=js&"
export * from "./tank.vue?vue&type=script&lang=js&"
import style0 from "./tank.vue?vue&type=style&index=0&id=37d4e77a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4e77a",
  null
  
)

export default component.exports